import React,{useEffect} from 'react';
import './App.css';
import { makeStyles } from "@material-ui/core/styles";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Typography from '@material-ui/core/Typography';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Box from '@material-ui/core/Box';
import Header from './components/header'
import ContentView from './components/card'
import Main from './components/main'
import TreeViews from './components/treeView'
import Aql from './components/aql';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    "& .PrivateTabIndicator-colorSecondary-14":{
      backgroundColor:"#3f51b5"
    }
  },
  auto: {
    width: "30%"
  },
  gridrow: {
    display: "inline-block",
    marginLeft: 5
  },  
  gridview: {
    // flex: 1,
    display: "inline-block",
    marginLeft: 10,
    marginBottom:10
  },
  bar:{
    backgroundColor:"white",
    color:"black",
    marginTop:-36,
   
  },
  indicator: {
    backgroundColor: '#3f51b5',
  },

}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function App() {
  const classes = useStyles();
  const [tabValue, setTabValue] = React.useState(0);

 
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div className="App">
      <Header />
     
      <AppBar position="static" className={classes.bar}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="tabs" classes={{
    indicator: classes.indicator
  }} >
      <Tab label="AQL" {...a11yProps(0)} />
          {/* <Tab label="GraphQL" {...a11yProps(1)}/> */}
        
        </Tabs>
      </AppBar>
     
      <TabPanel value={tabValue} index={0}>
        <Aql />
      </TabPanel>
      {/* <TabPanel value={tabValue} index={1} className={classes.panbg}>
        <TreeViews className={classes.panbg} />
      </TabPanel> */}

      {/* <ContentView /> */}
      {/* <Main /> */}

    </div>
  );
}

export default App;
